/**
 * نشان الزامی فرم — الگوی رایج فارسی: «عنوان *»
 * با inline-flex از جابه‌جایی bidi کاراکتر * جلوگیری می‌شود.
 */
export function renderFormRequiredMark(label, { required }) {
  return (
    <span className="app-form-required-label">
      {label}
      {required ? (
        <span className="app-form-required-mark" aria-hidden>
          *
        </span>
      ) : null}
    </span>
  );
}

/** مثل حالت optional آنت‌دیزاین، با ستارهٔ درست‌جایگاه برای فیلد اجباری */
export function renderFormRequiredMarkOptional(label, { required }) {
  return (
    <span className="app-form-required-label">
      {label}
      {required ? (
        <span className="app-form-required-mark" aria-hidden>
          *
        </span>
      ) : null}
      {!required ? <span className="ant-form-item-optional">(اختیاری)</span> : null}
    </span>
  );
}
